<app-background-image data-state="shipping"></app-background-image>
<app-topbar></app-topbar>

<app-sidebar [showNavigation]="true">
    <div style="height: 45px"></div>
    <ul class="nav flex-column navbar-nav">
        <li class="d-grid gap-2">
            <button
                class="btn btn-outline-primary btn-block"
                type="button"
                (click)="manageComponents()"
            >
                Components
            </button>
        </li>
        <li class="d-grid gap-2">
            <button
                class="btn btn-outline-primary btn-block"
                type="button"
                (click)="manageEventTypes()"
            >
                Event Types
            </button>
        </li>
        <li class="d-grid gap-2">
            <button
                class="btn btn-outline-primary btn-block required"
                type="button"
                (click)="manageMailingList()"
            >
                Mail Recipients
            </button>
        </li>
    </ul>
    <div style="height: 30px"></div>
    <form (ngSubmit)="accept()">
        <ul class="nav flex-column navbar-nav">
            <li class="d-grid gap-2">
                <button
                    class="btn btn-outline-danger btn-block"
                    type="button"
                    (click)="delete()"
                >
                    Delete
                </button>
            </li>
            <li class="d-grid gap-2">
                <button
                    type="submit"
                    class="btn btn-primary btn-block"
                    [disabled]="!inputValid"
                >
                    Update
                </button>
            </li>
        </ul>
    </form>
</app-sidebar>

<div class="main-content">
    <app-edit-project-inner [project]="project" (formIsDirty)="formIsDirty()"></app-edit-project-inner>
</div>
